import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import type { ApiClientError } from '@/lib/api-client';

import { fetchMaterialValuation, lockMaterialValuation, recomputeMaterialValuation } from './api';
import type { MaterialValuationDto } from './types';

const KEY = 'monthly-material-valuation' as const;

export const useMaterialValuation = (batchId: string | undefined) => {
  return useQuery<MaterialValuationDto | null, ApiClientError>({
    queryKey: [KEY, batchId],
    queryFn: () => fetchMaterialValuation(batchId!),
    enabled: !!batchId,
    placeholderData: (prev) => prev,
  });
};

export const useRecomputeMaterialValuation = (batchId: string | undefined) => {
  const qc = useQueryClient();
  return useMutation<MaterialValuationDto, ApiClientError, void>({
    mutationFn: () => recomputeMaterialValuation(batchId!),
    onSuccess: () => qc.invalidateQueries({ queryKey: [KEY, batchId] }),
  });
};

export const useLockMaterialValuation = (batchId: string | undefined) => {
  const qc = useQueryClient();
  return useMutation<MaterialValuationDto, ApiClientError, string>({
    mutationFn: (id) => lockMaterialValuation(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: [KEY, batchId] }),
  });
};
